import { render, staticRenderFns } from "./MainJouEqCard.vue?vue&type=template&id=6874dedf&scoped=true&"
import script from "./MainJouEqCard.vue?vue&type=script&lang=js&"
export * from "./MainJouEqCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouEqCard.vue?vue&type=style&index=0&id=6874dedf&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6874dedf",
  null
  
)

export default component.exports